import { format } from 'date-fns';

const getPeriodDateString = (type: string, dateRange: Date[]) => {
  let dateString;
  let dateFromValue;
  let dateToValue;
  let dateFrom;
  let dateTo;
  const today = new Date();

  if (dateRange.length) {
    const [from, to] = dateRange;

    dateFrom = from;
    dateTo = to;
  }

  switch (type) {
    case 'today':
      dateString = `transferDateFrom=${format(
        today,
        'yyyy-MM-dd',
      )}&transferDateTo=${format(today, 'yyyy-MM-dd')}`;
      dateFromValue = format(today, 'yyyy-MM-dd');
      dateToValue = format(today, 'yyyy-MM-dd');

      break;
    case 'week':
      dateString = `transferDateFrom=${format(
        new Date(today.getTime() - 604800000),
        'yyyy-MM-dd',
      )}&transferDateTo=${format(new Date(), 'yyyy-MM-dd')}`;
      dateFromValue = format(
        new Date(today.getTime() - 604800000),
        'yyyy-MM-dd',
      );
      dateToValue = format(new Date(), 'yyyy-MM-dd');

      break;
    case 'one-month':
      dateString = `transferDateFrom=${format(
        new Date(today.setMonth(today.getMonth() - 1)),
        'yyyy-MM-dd',
      )}&transferDateTo=${format(new Date(), 'yyyy-MM-dd')}`;
      dateFromValue = format(
        new Date(today.setMonth(today.getMonth() - 1)),
        'yyyy-MM-dd',
      );
      dateToValue = format(new Date(), 'yyyy-MM-dd');

      break;
    case 'two-months':
      dateString = `transferDateFrom=${format(
        new Date(today.setMonth(today.getMonth() - 2)),
        'yyyy-MM-dd',
      )}&transferDateTo=${format(new Date(), 'yyyy-MM-dd')}`;
      dateFromValue = format(
        new Date(today.setMonth(today.getMonth() - 2)),
        'yyyy-MM-dd',
      );
      dateToValue = format(new Date(), 'yyyy-MM-dd');

      break;
    case 'three-months':
      dateString = `transferDateFrom=${format(
        new Date(today.setMonth(today.getMonth() - 3)),
        'yyyy-MM-dd',
      )}&transferDateTo=${format(new Date(), 'yyyy-MM-dd')}`;
      dateFromValue = format(
        new Date(today.setMonth(today.getMonth() - 3)),
        'yyyy-MM-dd',
      );
      dateToValue = format(new Date(), 'yyyy-MM-dd');

      break;
    case 'six-months':
      dateString = `transferDateFrom=${format(
        new Date(today.setMonth(today.getMonth() - 6)),
        'yyyy-MM-dd',
      )}&transferDateTo=${format(new Date(), 'yyyy-MM-dd')}`;
      dateFromValue = format(
        new Date(today.setMonth(today.getMonth() - 6)),
        'yyyy-MM-dd',
      );
      dateToValue = format(new Date(), 'yyyy-MM-dd');

      break;
    case 'year':
      dateString = `transferDateFrom=${format(
        new Date(today.setMonth(today.getMonth() - 12)),
        'yyyy-MM-dd',
      )}&transferDateTo=${format(new Date(), 'yyyy-MM-dd')}`;
      dateFromValue = format(
        new Date(today.setMonth(today.getMonth() - 12)),
        'yyyy-MM-dd',
      );
      dateToValue = format(new Date(), 'yyyy-MM-dd');

      break;
    case 'custom':
      dateString = `transferDateFrom=${format(
        dateFrom as Date,
        'yyyy-MM-dd',
      )}&transferDateTo=${format(dateTo as Date, 'yyyy-MM-dd')}`;
      dateFromValue = dateFrom;
      dateToValue = dateTo;

      break;
    default:
      break;
  }

  return { dateString, dateFromValue, dateToValue };
};

export default getPeriodDateString;
